import Vue from 'vue';
import PageRecipientReferrals from '@/plugins/graphql/queries/v2/survey/page-recipient-referrals.gql';
import { OneTimePinModel } from '@/helpers/entities/models/OneTimePinModel';
export default Vue.extend({
    apollo: {
        pageRecipientReferrals: {
            query: PageRecipientReferrals,
            variables() {
                return {
                    pageRecipientUuid: this.pageRecipientUuid,
                };
            },
            update(data) {
                const referrals = data.pageRecipientReferrals.edges;
                const referralNodes = (pgr) => {
                    return new OneTimePinModel(pgr.node);
                };
                return referrals.map(referralNodes);
            },
        },
    },
    props: {
        pageRecipientUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pageRecipientReferrals: null,
        };
    },
    computed: {
        loading() {
            return this.$apollo.queries.pageRecipientReferrals.loading;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                pageRecipientReferrals: this.pageRecipientReferrals,
            });
        }
    },
});
